//  sessionStorage.setItem("isESignSubmitted", btoa(JSON.stringify(eSignCall)));

import GlobalStore from "../store/globalStore";

export const getStateFromLs = () => {
  let isESignSubmitted = sessionStorage.getItem("isESignSubmitted");
  if (isESignSubmitted !== null && isESignSubmitted !== undefined && isESignSubmitted !== "") {
    return JSON.parse(atob(sessionStorage.getItem("isESignSubmitted") || ""));
  }
  return null;

};

export const checkESignSubmitted = (applicationId: string) => {
  const state = getStateFromLs();
  if (state !== null && state && state.applicationId == applicationId && state.isESignSubmitted) {
    return true;
  } else {
    return false;
  }
};

export const disabledUploadForEsign = () => {
  if (GlobalStore?.stageStatus?.first_esign_initiated) {
    return true;
  }
  return false;
}